import { render, staticRenderFns } from "./addLiveCoupon.vue?vue&type=template&id=abb64fce&scoped=true&"
import script from "./addLiveCoupon.vue?vue&type=script&lang=ts&"
export * from "./addLiveCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./addLiveCoupon.vue?vue&type=style&index=0&id=abb64fce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb64fce",
  null
  
)

export default component.exports